import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useRemoveBonus = () => {
    const send = useGenericSend();

    return useCallback(async (bonusInstanceCode: string): Promise<Types.IUseRemoveBonusResponseData> => {
        const { data } = await send<Types.IUseRemoveBonusRequestData, Types.IUseRemoveBonusResponseData>({
            ID: 35577,
            reason: 'CancelByPlayer',
            responses: [35578, 35579],
            description: 'Remove bonus',
            bonusInstanceCode
        });

        return data;
    }, [send]);
};
